var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgAnchor = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 6.66669C11.381 6.66669 12.5003 5.5474 12.5003 4.16669C12.5003 2.78598 11.381 1.66669 10.0003 1.66669C8.61961 1.66669 7.50033 2.78598 7.50033 4.16669C7.50033 5.5474 8.61961 6.66669 10.0003 6.66669ZM10.0003 6.66669V18.3334M10.0003 18.3334C7.79019 18.3334 5.67057 17.4554 4.10777 15.8926C2.54497 14.3298 1.66699 12.2102 1.66699 10H4.16699M10.0003 18.3334C12.2105 18.3334 14.3301 17.4554 15.8929 15.8926C17.4557 14.3298 18.3337 12.2102 18.3337 10H15.8337",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAnchor, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/anchor.7c8e1164.svg";
export { ForwardRef as ReactComponent };